import React from 'react';
import { useCrumbs } from '../breadcrumbs/useCrumbs';

export const MobilePageTitle: React.FC = () => {
  const { leafLabel } = useCrumbs();

  return (
    <h1
      className="text-sm font-semibold tracking-tight text-navbar-foreground truncate max-w-[180px] xs:max-w-[240px] sm:max-w-[320px]"
      title={leafLabel}
    >
      {leafLabel}
    </h1>
  );
};
